import { FC } from 'react'
import { Row, Col, Text, Button, Icon } from '@/client/components'
import { useRouterPush } from '@/client/hooks'
import * as S from './styles'
import { PantoneColorsProps } from './types'

export const PantoneColors: FC<PantoneColorsProps> = ({
  pentonetitleleft,
  pentonedescleft,
  pentonetitleright,
  pentonedescright
}) => (
  <S.PantoneColorsBlock>
    <Row>
      <Col xs='12' xl='5'>
        <S.PantoneBlock>
          <Col xs='12' xl='12' noGutter>
            <S.GapSec>
              <Icon name='adobe_tools' size='s8' />
            </S.GapSec>
          </Col>
          <Text as='h4' size='lg' family='text' weight='semiBlack' margin='0 0 1rem'>
            {pentonetitleleft}
          </Text>
          <span className='block-p' dangerouslySetInnerHTML={{ __html: pentonedescleft }} />
        </S.PantoneBlock>
      </Col>
      <Col xs='12' xl='7'>
        <S.PantoneBlock>
          <Text as='h4' size='h3' family='text' weight='semiBlack' margin='0 0 1rem'>
            <Icon name='pantone' size='s8' />
          </Text>
          <Text as='h4' size='lg' family='text' weight='semiBlack' margin='0 0 1rem'>
            {pentonetitleright}
          </Text>
          <span className='block-p' dangerouslySetInnerHTML={{ __html: pentonedescright }} />
        </S.PantoneBlock>
      </Col>
    </Row>
  </S.PantoneColorsBlock>
)
